<template>
    <div class="service">
        <div class="title">请问您需要什么帮助？</div>
        <div class="items">
            <div class="item">
                <div class="item-title"> <div class="item-icon"></div>从这里开始</div>
                <div class="item-texts" @click="goHelp(ident1)">
                    <div class="item-icon"></div>
                    <div class="item-text">新手必读</div>
                    <div class="item-icon-right"></div>
                </div>
                <div class="item-texts" @click="goHelp(ident3)">
                    <div class="item-icon"></div>
                    <div class="item-text">功能介绍</div>
                    <div class="item-icon-right"></div>
                </div>
                <div class="item-texts" @click="goHelp(ident2)">
                    <div class="item-icon"></div>
                    <div class="item-text">安装教程</div>
                    <div class="item-icon-right"></div>
                </div>
                <div class="item-texts" @click="goHelp(ident11)">
                    <div class="item-icon"></div>
                    <div class="item-text">常见问题</div>
                    <div class="item-icon-right"></div>
                </div>
            </div>
            <div class="item">
                <div class="item-title"> <div class="item-icon item-icon2"></div>远程文件</div>
                <div class="item-texts" @click="goHelp(ident4_1)">
                    <div class="item-icon"></div>
                    <div class="item-text">远程文件介绍</div>
                    <div class="item-icon-right"></div>
                </div>
                <div class="item-texts" @click="goHelp(ident4_1)">
                    <div class="item-icon"></div>
                    <div class="item-text">远程文件使用教程</div>
                    <div class="item-icon-right"></div>
                </div>
                <div class="item-texts" @click="goHelp(ident4_1)">
                    <div class="item-icon"></div>
                    <div class="item-text">自定义远程文件</div>
                    <div class="item-icon-right"></div>
                </div>
                <div class="item-texts" @click="goHelp(ident4_3)">
                    <div class="item-icon"></div>
                    <div class="item-text">系统挂载教程（适合专业用户）</div>
                    <div class="item-icon-right"></div>
                </div>
            </div>
            <div class="item">
                <div class="item-title"> <div class="item-icon item-icon3"></div>使用场景</div>
                <div class="item-texts" @click="goHelp(ident4_2)">
                    <div class="item-icon"></div>
                    <div class="item-text">远程访问Nas</div>
                    <div class="item-icon-right"></div>
                </div>
                <div class="item-texts" @click="goHelp(ident3_1)">
                    <div class="item-icon"></div>
                    <div class="item-text">远程访问Windows/mac</div>
                    <div class="item-icon-right"></div>
                </div>
                <div class="item-texts" @click="goHelp(ident_ssh)">
                    <div class="item-icon"></div>
                    <div class="item-text">远程访问SSH</div>
                    <div class="item-icon-right"></div>
                </div>

            </div>
            <div class="item">
                <div class="item-title"> <div class="item-icon item-icon4"></div>快捷访问</div>
                <div class="item-texts" @click="goHelp(ident3_4)">
                    <div class="item-icon"></div>
                    <div class="item-text">快捷访问介绍</div>
                    <div class="item-icon-right"></div>
                </div>
                <div class="item-texts" @click="goHelp(ident3_4)">
                    <div class="item-icon"></div>
                    <div class="item-text">添加快捷访问</div>
                    <div class="item-icon-right"></div>
                </div>
                <div class="item-texts" @click="goHelp(ident3_4)">
                    <div class="item-icon"></div>
                    <div class="item-text">如何快捷访问</div>
                    <div class="item-icon-right"></div>
                </div>
                <div class="item-texts" @click="goHelp(ident3_4)">
                    <div class="item-icon"></div>
                    <div class="item-text">快捷访问常见问题问</div>
                    <div class="item-icon-right"></div>
                </div>
            </div>
            <div class="item">
                <div class="item-title"> <div class="item-icon item-icon5"></div>相册备份</div>
                <div class="item-texts" @click="goHelp(ident5)">
                    <div class="item-icon"></div>
                    <div class="item-text">相册备份介绍</div>
                    <div class="item-icon-right"></div>
                </div>
                <div class="item-texts" @click="goHelp(ident5)">
                    <div class="item-icon"></div>
                    <div class="item-text">相册备份教程</div>
                    <div class="item-icon-right"></div>
                </div>
                <div class="item-texts" @click="goHelp(ident5)">
                    <div class="item-icon"></div>
                    <div class="item-text">常见问题</div>
                    <div class="item-icon-right"></div>
                </div>

            </div>
            <div class="item">
                <div class="item-title"> <div class="item-icon item-icon6"></div>常见问题</div>
                <div class="item-texts" @click="goHelp(ident11)">
                    <div class="item-icon"></div>
                    <div class="item-text">高频常见问题</div>
                    <div class="item-icon-right"></div>
                </div>
                <div class="item-texts" @click="goHelp(ident12)">
                    <div class="item-icon"></div>
                    <div class="item-text">账户问题</div>
                    <div class="item-icon-right"></div>
                </div>
                <div class="item-texts" @click="goHelp(ident13)">
                    <div class="item-icon"></div>
                    <div class="item-text">付费会员</div>
                    <div class="item-icon-right"></div>
                </div>

            </div>
            <div class="item">
                <div class="item-title"> <div class="item-icon item-icon7"></div>异地组网</div>
                <div class="item-texts" @click="goHelp(ident7)">
                    <div class="item-icon"></div>
                    <div class="item-text">异地组网介绍</div>
                    <div class="item-icon-right"></div>
                </div>
                <div class="item-texts" @click="goHelp(ident7_1)">
                    <div class="item-icon"></div>
                    <div class="item-text">组网访问</div>
                    <div class="item-icon-right"></div>
                </div>
                <div class="item-texts" @click="goHelp(ident7_2)">
                    <div class="item-icon"></div>
                    <div class="item-text">自定义组网</div>
                    <div class="item-icon-right"></div>
                </div>
                <div class="item-texts" @click="goHelp(ident7_3)">
                    <div class="item-icon"></div>
                    <div class="item-text">全网映射</div>
                    <div class="item-icon-right"></div>
                </div>
            </div>
            <div class="item">
                <div class="item-title"> <div class="item-icon item-icon8"></div>内网穿透</div>
                <div class="item-texts" @click="goHelp(ident9)">
                    <div class="item-icon"></div>
                    <div class="item-text">内网穿透介绍</div>
                    <div class="item-icon-right"></div>
                </div>
                <div class="item-texts" @click="goHelp(ident9)">
                    <div class="item-icon"></div>
                    <div class="item-text">创建内网穿透</div>
                    <div class="item-icon-right"></div>
                </div>
                <div class="item-texts" @click="goHelp(ident9)">
                    <div class="item-icon"></div>
                    <div class="item-text">访问规则</div>
                    <div class="item-icon-right"></div>
                </div>
                <div class="item-texts" @click="goHelp(ident9)">
                    <div class="item-icon"></div>
                    <div class="item-text">内网穿透常见问题</div>
                    <div class="item-icon-right"></div>
                </div>
            </div>
            <div class="item">
                <div class="item-title"> <div class="item-icon item-icon9"></div>原生桌面</div>
                <div class="item-texts" @click="goHelp(ident6_1)">
                    <div class="item-icon"></div>
                    <div class="item-text">访问Windows桌面</div>
                    <div class="item-icon-right"></div>
                </div>
                <div class="item-texts" @click="goHelp(ident6_2)">
                    <div class="item-icon"></div>
                    <div class="item-text">访问mac桌面</div>
                    <div class="item-icon-right"></div>
                </div>

            </div>
        </div>
        <Foot></Foot>
    </div>
</template>

<script>
    import {mapActions} from "vuex";
    import Foot from "@/components/Foot.vue";
    export default {
        name: "service",
        components: {
            Foot,
        },
        data: function () {
            return {
              ident1:"",
              ident2:"docs/2-安装与绑定.html",
              ident3:"docs/3-如何使用.html",
              ident4:"docs/4-远程文件.html",
              ident4_1:"docs/4.1-节点小宝远程文件.html",
              ident4_2:"docs/4.2-远程访问NAS文件.html",
              ident4_3:"docs/4.3-挂载磁盘教程.html",
              ident3_1:"docs/3.1-远程桌面.html",
              ident3_4:"docs/3.4-快捷访问.html",
              ident5:"docs/5-相册备份.html",
              ident11:"docs/11-常见问题.html",
              ident12:"docs/12-账户问题.html",
              ident13:"docs/13-付费会员.html",
              ident7:"docs/7-异地组网.html",
              ident7_1:"docs/7.1-设备组网.html",
              ident7_2:"docs/7.2-自定义组网.html",
              ident7_3:"docs/7.3-全网映射.html",
              ident9:"docs/9-内网穿透.html",
              ident6_1:"docs/6.1-远程Windows桌面.html",
              ident6_2:"docs/6.2-远程mac桌面.html",
              ident_ssh:"docs/远程访问SSH.html",
              ident8:"docs/8-全网映射.html",
            };
        },
        methods: {
            ...mapActions([
                "sendLog"
            ]),
            goHelp: function (ident) {
                this.sendLog(["PC_service_clicked",ident]);
                if(process.env.NODE_ENV == 'development'){
                    window.location.href = "http://127.0.0.1:4000/" +  ident;
                }else{
                    window.location.href = "/helpcenter_v3/" +  ident;
                }
            },

        },
    }
</script>

<style scoped lang="less">
    .service{
        padding-top: 82px;
        background-image: url("../assets/service/bg.png");
        background-repeat: no-repeat;
        background-size: 100% 100%;
        .title{
            margin-bottom: 45px;
            color: rgba(29, 31, 36, 1);
            font-size: 48px;
            font-weight: 700;
            line-height: 72px;
            text-align: center;
        }
        .items{
            margin: 0 auto;
            padding-bottom: 80px;
            width: 1290px;
            text-align: center;
            .item{
                padding-top: 20px;
                padding-left: 24px;
                margin: 15px;
                display: inline-block;
                width: 400px;
                height: 240px;
                border-radius: 20px;
                box-shadow: 0px 4px 40px 0px rgba(232, 237, 252, 0.5);
                background: rgba(255, 255, 255, 1);
                overflow: hidden;
                text-align: left;
                box-sizing: border-box;

                .item-title{
                    margin-bottom: 16px;
                    line-height: 40px;
                    color: rgba(29, 31, 36, 1);
                    font-size: 20px;
                    font-weight: 500;
                    .item-icon{
                        display: inline-block;
                        margin-right: 12px;
                        vertical-align: top;
                        width: 40px;
                        height: 40px;
                        background-image: url("../assets/service/s1.png");
                        background-repeat: no-repeat;
                        background-size: 100% 100%;
                    }
                    .item-icon2{
                        background-image: url("../assets/service/s3.png");
                    }
                    .item-icon3{
                        background-image: url("../assets/service/s9.png");
                    }
                    .item-icon4{
                        background-image: url("../assets/service/s2.png");
                    }
                    .item-icon5{
                        background-image: url("../assets/service/s4.png");
                    }
                    .item-icon6{
                        background-image: url("../assets/service/s7.png");
                    }
                    .item-icon7{
                        background-image: url("../assets/service/s6.png");
                    }
                    .item-icon8{
                        background-image: url("../assets/service/s5.png");
                    }
                    .item-icon9{
                        background-image: url("../assets/service/s8.png");
                    }
                }
                .item-texts{
                    position: relative;
                    margin-top: 8px;
                    padding-left: 10px;
                    padding-right: 40px;
                    line-height: 30px;
                    cursor: pointer;

                    .item-icon{
                        position: absolute;
                        left: 0;
                        top: 12px;
                        width: 4px;
                        height: 4px;
                        background: rgba(55, 114, 255, 1);
                        border-radius: 50%;
                    }
                    .item-text{
                        color: rgba(87, 87, 108, 1);
                        font-size: 14px;
                        white-space: nowrap;
                        overflow: hidden;
                        text-overflow: ellipsis;
                    }
                    .item-icon-right{
                        position: absolute;
                        top: 6px;
                        right: 20px;
                        width: 16px;
                        height: 16px;
                        background-image: url("../assets/service/s1_right.svg");
                        background-repeat: no-repeat;
                        background-size: 100% 100%;
                    }
                }

                .item-texts:hover{

                    .item-text{
                        color: #3772FF;
                    }

                    .item-icon-right{
                        background-image: url("../assets/service/s1_right_blue.svg");
                    }
                }
            }
        }
    }
</style>